import { useState } from "react";
import styles from "./Support.module.css";
import { Note, Page } from "../../../helbest";
import { Address, Email, PhoneNumber, WhatsappNumber } from "../../../base/env";
import HeaderBack from "../../../helbest/HeaderBack/HeaderBack";
import { useTranslation } from "react-i18next";
import { Button, Drawer } from "antd";
import { ReactComponent as CallIcon } from "../../../assets/svg/call.svg";
import { ReactComponent as WhatsappIcon } from "../../../assets/svg/whatsapp.svg";
import { ReactComponent as LocationIcon } from "../../../assets/svg/location-support.svg";
import { ReactComponent as EmailIcon } from "../../../assets/svg/email.svg";
import { usePagesQuery, usePageTypesQuery } from "../../../saleor/api";
import { mapEdgesToNodes } from "../../../base/utils";
import Loading from "../../components/Loading/Loading";
import FaqItem from "../Faq/FaqItem/FaqItem";

const Footer = ({ openModalHandler }) => {
  const { t } = useTranslation();
  return (
    <div className="page-fixed-footer-container">
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        size="large"
        onClick={() => {
          openModalHandler();
        }}
      >
        {t("contact.title")}
      </Button>
    </div>
  );
};

const Support = () => {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const { t } = useTranslation();

  const { data: pageTypesData } = usePageTypesQuery({
    variables: {
      first: 20,
    },
    onError: (error) => {
      Note.error(error.message);
    },
  });

  const faqPageId =
    pageTypesData &&
    mapEdgesToNodes(pageTypesData.pageTypes.edges)
      .filter((node) => node.slug === "faq")
      .map((node) => node.id);

  const { loading } = usePagesQuery({
    variables: {
      first: 100,
      filter: { pageTypes: pageTypesData && faqPageId },
    },
    onCompleted(data) {
      const faqs = mapEdgesToNodes(data?.pages?.edges).map((item) => ({
        ...item,
        content: item.content ? JSON.parse(item.content) : item.content,
      }));
      setData(faqs);
    },
    skip: !pageTypesData || (pageTypesData && !faqPageId.length),
    onError: (error) => {
      Note.error(error.message);
    },
  });

  function openModal() {
    setOpen(true);
  }

  return (
    <Page
      className="page-faq"
      address="/"
      show
      showFooter
      headerFix
      logo
      back
      customHeader={<HeaderBack title={t("drawer.help")} />}
      footer={<Footer openModalHandler={openModal} />}
    >
      <div className={styles.FaqContainer}>
        {loading && (
          <div className="text-center">
            <Loading />
          </div>
        )}
        {!loading &&
          data.map((dataItem) => {
            return <FaqItem {...dataItem} />;
          })}
      </div>
      <Drawer
        closeIcon={null}
        rootStyle={{
          boxShadow: "none",
        }}
        placement="bottom"
        onClose={() => setOpen(false)}
        open={open}
        classNames={{
          content: styles.DrawerContent,
          header: styles.DrawerHeader,
        }}
        height={370}
      >
        <div className={styles.ContactContainer}>
          <a
            href={`tel:${PhoneNumber}`}
            className={styles.ContactItem}
            target="_blank"
          >
            <CallIcon className={styles.ContactItemIcon} />
            <span>{PhoneNumber}</span>
          </a>
          <a
            href={`mailto:${Email}`}
            className={styles.ContactItem}
            target="_blank"
          >
            <EmailIcon className={styles.ContactItemIcon} />
            <span>{Email}</span>
          </a>
          <a
            href={`https://wa.me/${WhatsappNumber}?text=Gmall`}
            className={styles.ContactItem}
            target="_blank"
          >
            <WhatsappIcon className={styles.ContactItemIcon} />
            <span>{WhatsappNumber}</span>
          </a>
          <a href={"#"} className={styles.ContactItem}>
            <LocationIcon className={styles.ContactItemIcon} />
            <span>{Address}</span>
          </a>
        </div>
      </Drawer>
    </Page>
  );
};

export default Support;
